import React from 'react';
import iconPrimary from '../assets/brand/icon-transparent.svg';

/**
 * First-visit entry modal.
 * - Dark semi-transparent overlay: rgba(10,20,18,0.85)
 * - Ivory card with two clickable visitor-type cards
 * - No close/skip user must pick one
 */
const EntryModal = ({ onSelect }) => {
  const handleSelect = (type) => {
    try {
      localStorage.setItem('cc_visitor_type', type);
    } catch (e) {
      // ignore (private mode etc.)
    }
    onSelect(type);
  };

  const cards = [
    {
      type: 'talent',
      label: "I'm looking for work",
      description:
        "Jobs, gigs, residencies and opportunities across India's arts and cultural sector"
    },
    {
      type: 'employer',
      label: "I'm looking to hire",
      description:
        'Find vetted freelancers and gig workers, full-time talent and casual staff for your gallery, festival, event, museum or organisation'
    }
  ];

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center px-6 md:px-10"
      style={{ backgroundColor: 'rgba(10,20,18,0.85)' }}
      data-testid="entry-modal"
      role="dialog"
      aria-modal="true"
      aria-label="Welcome to CultureCareers"
    >
      <div
        className="w-full max-w-3xl rounded-xl px-6 md:px-12 py-10 md:py-14"
        style={{ backgroundColor: '#F0EBE2' }}
      >
        <img
          src={iconPrimary}
          alt=""
          aria-hidden="true"
          className="h-12 w-auto mb-6"
          width="50"
          height="48"
        />
        <p
          className="text-xs uppercase tracking-[0.25em] font-medium mb-5"
          style={{ color: '#D4820A' }}
        >
          Welcome to CultureCareers
        </p>
        <h2
          className="text-3xl md:text-4xl font-normal tracking-tight mb-3"
          style={{ fontFamily: 'Cormorant Garamond, serif', color: '#0F2942' }}
        >
          What brings you here today?
        </h2>
        <p className="text-base md:text-lg leading-relaxed mb-10" style={{ color: '#0F2942' }}>
          Tell us who you are and we&rsquo;ll show you what&rsquo;s most relevant.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 items-stretch">
          {cards.map((c) => (
            <button
              key={c.type}
              type="button"
              onClick={() => handleSelect(c.type)}
              className="flex flex-col text-left rounded-xl p-6 md:p-7 transition-all hover:-translate-y-0.5 hover:shadow-md h-full"
              style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #F0EBE2'
              }}
              data-testid={`entry-modal-${c.type}`}
              onMouseEnter={(e) =>
                (e.currentTarget.style.borderColor = 'rgba(212,130,10,0.6)')
              }
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = '#F0EBE2')}
            >
              <h3
                className="text-xl md:text-2xl font-bold tracking-tight mb-3 whitespace-nowrap"
                style={{ fontFamily: "'Playfair Display', serif", color: '#0F2942' }}
              >
                {c.label}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: '#0F2942' }}>
                {c.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EntryModal;
